// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"596":"e7b26782","611":"ba185d37"}[chunkId] + ".chunk.js";
};